import React, { ForwardedRef } from 'react';
import { GroupBase, mergeStyles, SelectInstance } from 'react-select';
import AsyncSelect, { AsyncProps } from 'react-select/async';
import { hofForwardRef } from '../../../utils/types';
import { EmptyComponent, getDefaultStyles } from './SelectUtils';
import { useFloatingLayerContext } from '../../FloatingManager';

/*
 * This component should be used when we have to load options
 * from a remote source as the user types in search input
 * More info: https://react-select.com/async
 */

export default hofForwardRef(
  <
    Option,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>,
  >(
    {
      styles,
      components,
      menuPlacement,
      placeholder,
      promiseSearch,
      ...props
    }: AsyncProps<Option, IsMulti, Group> & {
      promiseSearch: (inputValue: string) => Promise<Option[]>;
    },
    ref: ForwardedRef<SelectInstance<Option, IsMulti, Group>>,
  ) => {
    const zIndex = useFloatingLayerContext();

    const selectStyles = mergeStyles(
      getDefaultStyles<Option, IsMulti, Group>(zIndex),
      styles,
    );
    const promiseOptions = (inputValue: string) => {
      return new Promise<Option[]>((resolve) => {
        setTimeout(() => {
          resolve(promiseSearch(inputValue));
        }, 300);
      });
    };
    return (
      <AsyncSelect
        {...props}
        ref={ref}
        menuPlacement={menuPlacement || 'auto'}
        placeholder={placeholder || ''}
        styles={selectStyles}
        isClearable={props?.isClearable ?? true}
        loadOptions={promiseOptions}
        components={{
          MultiValueRemove: EmptyComponent,
          DropdownIndicator: EmptyComponent,
          IndicatorSeparator: EmptyComponent,
          ClearIndicator: EmptyComponent,
          ...components,
        }}
      />
    );
  },
);
